
/// filter only wanted pages
// BASE_PATH and EXAM_TYPE are window globals injected by EJS at render time.
// BASE_PATH handles subpath routing (K3s); EXAM_TYPE selects the business unit.
var _basePath = BASE_PATH;
var _isTcf = EXAM_TYPE === 'tcf';

// Normalise the current pathname: strip BASE_PATH prefix if present.
// In production the reverse proxy strips the prefix before Express, so the
// browser sees the full subpath (e.g. /tcf-examsignup/tcf-form). In tests
// there is no proxy, so the browser sees the bare path (/tcf-form). Stripping
// the prefix here makes the dispatch logic work in both environments.
var _rawPath = window.location.pathname;
var _page = (_basePath && _rawPath.indexOf(_basePath) === 0)
    ? _rawPath.slice(_basePath.length) || '/'
    : _rawPath;

var _validPaths = ['/', '/exams-form', '/tcf-form'];

if (_validPaths.indexOf(_page) !== -1) {
    var _routedPage = _page;
    if (_routedPage === '/') {
        // Dispatch to the right home module for this business unit
        _routedPage = _isTcf ? '/tcf-home' : '/home';
    }
    // remove leading slash
    _routedPage = _routedPage.substring(1);
    var pageModule = require('./pages/' + _routedPage);
    pageModule.run();
}


